var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichText = void 0;
const react_1 = __importDefault(require("react"));
const rich_text_react_renderer_1 = require("@contentful/rich-text-react-renderer");
const rich_text_types_1 = require("@contentful/rich-text-types");
const core_1 = require("@wheelroom/core");
const get_localized_value_1 = require("./get-localized-value");
exports.RichText = (props) => {
    const textProps = props;
    const options = {
        renderText: (text) => {
            return text
                .split('\n')
                .reduce((children, textSegment, index) => {
                return [...children, index > 0 && react_1.default.createElement("br", { key: index }), textSegment];
            }, []);
        },
        renderMark: {
            [rich_text_types_1.MARKS.BOLD]: (text) => (react_1.default.createElement(core_1.Strong, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.strong }) }, text)),
            [rich_text_types_1.MARKS.CODE]: (code) => (react_1.default.createElement(core_1.Code, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.code }) }, code)),
        },
        renderNode: {
            [rich_text_types_1.BLOCKS.PARAGRAPH]: (_node, children) => {
                const isCode = _node.content[0].marks &&
                    _node.content[0].marks.length &&
                    _node.content[0].marks[0].type === 'code';
                if (isCode) {
                    return (react_1.default.createElement(core_1.Pre, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.pre }) }, children));
                }
                else {
                    return (react_1.default.createElement(core_1.Paragraph, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.p }) }, children));
                }
            },
            [rich_text_types_1.BLOCKS.QUOTE]: (_node, children) => {
                return (react_1.default.createElement(core_1.Blockquote, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.blockquote }) }, children));
            },
            [rich_text_types_1.BLOCKS.UL_LIST]: (_node, children) => {
                return (react_1.default.createElement(core_1.Ul, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.ul }) }, children));
            },
            [rich_text_types_1.BLOCKS.OL_LIST]: (_node, children) => {
                return (react_1.default.createElement(core_1.Ol, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.ol }) }, children));
            },
            [rich_text_types_1.BLOCKS.LIST_ITEM]: (_node, children) => {
                return (react_1.default.createElement(core_1.Li, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.li }) }, children));
            },
            [rich_text_types_1.INLINES.HYPERLINK]: (node, children) => {
                const uri = node.data.uri;
                return (react_1.default.createElement(core_1.ALink, { href: uri, wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.inlinesHyperlink }) }, children));
            },
            [rich_text_types_1.INLINES.ENTRY_HYPERLINK]: (node, children) => {
                const internalPath = node.data.target.fields &&
                    node.data.target.fields.path[textProps.locale];
                return (react_1.default.createElement(core_1.GLink, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.entryHyperlink }), to: internalPath }, children));
            },
            [rich_text_types_1.BLOCKS.HEADING_1]: (_node, children) => (react_1.default.createElement(core_1.H1, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h1 }) }, children)),
            [rich_text_types_1.BLOCKS.HEADING_2]: (_node, children) => (react_1.default.createElement(core_1.H2, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h2 }) }, children)),
            [rich_text_types_1.BLOCKS.HEADING_3]: (_node, children) => (react_1.default.createElement(core_1.H3, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h3 }) }, children)),
            [rich_text_types_1.BLOCKS.HEADING_4]: (_node, children) => (react_1.default.createElement(core_1.H4, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h4 }) }, children)),
            [rich_text_types_1.BLOCKS.HEADING_5]: (_node, children) => (react_1.default.createElement(core_1.H5, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h5 }) }, children)),
            [rich_text_types_1.BLOCKS.HEADING_6]: (_node, children) => (react_1.default.createElement(core_1.H6, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.h6 }) }, children)),
            [rich_text_types_1.BLOCKS.HR]: () => (react_1.default.createElement(core_1.Hr, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.hr }) })),
            [rich_text_types_1.BLOCKS.EMBEDDED_ENTRY]: (node) => {
                const fields = node.data.target.fields;
                if (!fields) {
                    console.log('Warning: embedded asset fields not found, try npx gatsby clean');
                    return null;
                }
                const embedProps = {
                    code: { code: get_localized_value_1.getLocalizedValue(textProps.locale, fields.code) },
                    type: get_localized_value_1.getLocalizedValue(textProps.locale, fields.type),
                    wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.embed }),
                };
                return react_1.default.createElement(core_1.Embed, Object.assign({}, embedProps));
            },
            [rich_text_types_1.BLOCKS.EMBEDDED_ASSET]: (node) => {
                const fields = node.data.target.fields;
                if (!fields) {
                    console.log('Warning: embedded asset fields not found, try npx gatsby clean');
                    return null;
                }
                const localizedFile = get_localized_value_1.getLocalizedValue(textProps.locale, fields.file);
                const localizedTitle = get_localized_value_1.getLocalizedValue(textProps.locale, fields.title);
                const localizedDescription = get_localized_value_1.getLocalizedValue(textProps.locale, fields.description);
                const contentType = localizedFile.contentType;
                if (!contentType || !contentType.includes('/')) {
                    return null;
                }
                const contentTypeSplit = contentType.split('/');
                if (contentTypeSplit[0] === 'image') {
                    const media = {
                        title: localizedTitle,
                        description: localizedDescription,
                        fluid: {
                            src: localizedFile.url + '?q=75',
                        },
                    };
                    return (react_1.default.createElement(core_1.Image, { key: node.data.target.id, includeFigcaption: false, media: media, wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.image }) }));
                }
                if (contentTypeSplit[0] === 'video') {
                    const media = {
                        title: localizedTitle,
                        description: localizedDescription,
                        file: {
                            url: localizedFile.url,
                            fileName: localizedFile.name,
                            contentType: localizedFile.contentType,
                        },
                    };
                    return (react_1.default.createElement(core_1.Video, { key: node.data.target.id, media: media, includeTitle: false, includeDescription: false, title: localizedTitle, description: localizedDescription, wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style.video }) }));
                }
                return null;
            },
        },
    };
    return (react_1.default.createElement(core_1.Box, { wheel: Object.assign(Object.assign({}, textProps.wheel), { style: textProps.wheel.style }) }, rich_text_react_renderer_1.documentToReactComponents(props.textJson, options)));
};
//# sourceMappingURL=rich-text.js.map